import React from "react";
import styled from "styled-components";
import { Container, Help, Titulo } from "./styles";
import IconePago from "../../Assets/pago.png";

interface Props {
  databaixa: string | null;
}

const InfoWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const TextoData = styled.p`
  margin-top: 8px;
  font-size: 0.9rem;
  font-weight: 500;
  color: #2e7d32;
  font-style: italic;
  text-align: center;
`;

export const PagoDiv = ({ databaixa }: Props) => {
  return (
    <Help>
      <Container>
        <InfoWrapper>
          <Titulo>PAGO</Titulo>
          <img src={IconePago} style={{ width: "40px" }} />
        </InfoWrapper>
        {databaixa && (
          <TextoData>
            Data de baixa: <strong>{new Date(databaixa).toLocaleDateString("pt-BR")}</strong>
          </TextoData>
        )}
      </Container>
    </Help>
  );
};
